import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useGet } from '../hooks/useGet'
import { useConfirm } from '../hooks/useConfirm'
import { useDelete } from '../hooks/useDelete'
import { RadAppLayout } from '../common/RadAppLayout'
import { RadButton } from '../common/RadButton'
import { RadHeader } from '../common/RadHeader'
import { RadSpaceBetween } from '../common/RadSpaceBetween'
import { CollectionDetailContent } from './CollectionDetailContent'

export function CollectionDetail () {
  const navigate = useNavigate()
  const { collectionId } = useParams()
  const { data: collection } = useGet(`/api/collection/${collectionId}`, true)
  const { data: userInfo } = useGet('/api/user/current')
  const confirmDelete = useConfirm('Delete collection?', 'Delete collection permanently? This action cannot be undone.', 'Delete', () => { remove() })
  const remove = useDelete(`/api/collection/${collectionId}`, () => navigate('/collection'))

  function edit (evt) {
    evt.preventDefault()
    navigate('edit')
  }

  if (collection != null && userInfo != null) {
    const canEdit = userInfo.roles.some((x) => x.name === 'Admin') ||
      userInfo.roles.some((x) => x.permissions.some((y) => y.name === 'Collection Update'))
    const canDelete = userInfo.roles.some((x) => x.name === 'Admin') ||
      userInfo.roles.some((x) => x.permissions.some((y) => y.name === 'Collection Delete'))

    return (
      <RadAppLayout
        name={collection.name}
        contentHeader={
          <RadHeader
            variant='h1'
            actions={
              <RadSpaceBetween direction='horizontal' size='xs'>
                {canEdit && <RadButton onClick={edit}>Edit</RadButton>}
                {canDelete && <RadButton onClick={confirmDelete}>Delete</RadButton>}
              </RadSpaceBetween>
            }
          >
            {collection.name}
          </RadHeader>
        }
        content={<CollectionDetailContent collection={collection} />}
      />
    )
  }
}
